import { SERVICES } from "@/config/business";
import { WhatsAppButton } from "./CtaButtons";

const ServiceCard = ({ service }) => (
  <article
    data-testid={`service-card-${service.id}`}
    className="group flex flex-col overflow-hidden rounded-2xl border border-[#E7E2DA] bg-white shadow-[0_4px_20px_-2px_rgba(44,39,32,0.05)] transition-[box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-[0_16px_32px_-4px_rgba(44,39,32,0.10)]"
  >
    <div className="overflow-hidden">
      <img
        src={service.image}
        alt={service.alt}
        loading="lazy"
        decoding="async"
        className="aspect-[16/10] w-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
    </div>
    <div className="flex flex-1 flex-col p-6">
      <h3 className="font-serif text-xl font-medium tracking-tight text-[#1C1917] sm:text-2xl">
        {service.name}
      </h3>
      <p className="mt-2 flex-1 text-sm leading-relaxed text-[#57534E]">{service.description}</p>
      <WhatsAppButton
        message={service.message}
        label="Book This Experience"
        testId={`service-card-${service.id}-whatsapp-btn`}
        className="mt-5 w-full"
      />
    </div>
  </article>
);

const Services = () => (
  <section id="services" className="scroll-mt-24 bg-[#F4EFEA] py-16 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#9E7B36]">
          Our Experiences
        </p>
        <h2 className="mt-3 font-serif text-3xl font-medium tracking-tight text-[#1C1917] sm:text-4xl">
          Massage &amp; Wellness Experiences
        </h2>
        <p className="mt-4 text-sm text-[#57534E] sm:text-base">
          Choose an experience that suits your relaxation and wellness needs.
        </p>
      </div>
      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((service) => (
          <ServiceCard key={service.id} service={service} />
        ))}
      </div>
    </div>
  </section>
);

export default Services;
